import React from 'react';
import { Collapse, Table, Input, Col, Button, Modal, ModalBody, ModalFooter, UncontrolledTooltip, Alert, ModalHeader } from 'reactstrap';
import LessonCollapsable from './LessonCollapsable'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import arrayMove from 'array-move';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import sortByPropText from "../../../../helpers/content/manageSets/sortByPropText";
import { courses } from '../../../../redux/actions/courses'
import { connect } from 'react-redux'
import { PulseLoader } from 'react-spinners';
import {forOwn , values} from 'mout/object'
import { get } from 'lodash'
const DragHandle = sortableHandle(() => <span className="drag-handle mr-2"></span>);
const SortableItem = sortableElement(({ value, toggle, toggleCard, index, lastItem, onSortEnd, reArrange,  addLesson, section, updateLessonIndex }) => <LessonCollapsable updateLessonIndex={updateLessonIndex} section={section} addLesson={addLesson} reArrange={reArrange} onSortEnd={onSortEnd} lastItem={lastItem} index={index} toggleCard={toggleCard} toggle={toggle} value={value} />);
const SortableContainer = sortableContainer(({ children }) => {return <tbody>{children}</tbody>;});


// TODO :   Set sorting functionality and display the
//          DECKS, ITEMS, and RULES coloumns in the lesson table,
//          when the db functionality for them is impleemneted.


class SectionCollapsable extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            collapse: false,
            addSection: false,
            showMoveModal: false,
            showPublishModal: false,
            showNodeModal: false,
            items: [],
            currentOrder: '',
            sortType : '',
            sortDirection: true,
            name : '',
            diff : [],
            selectedNode: '',
            reArrange: false
        };
    }

    componentDidUpdate(prevProps,prevState) {
        if (this.props.toggleCard) {
            this.props.toggle !== prevProps.toggle && this.setState({ collapse: false })
        }
        this.props.sectionToggle !== prevProps.sectionToggle && this.setState({ collapse: false })
        if((this.props.reArrangeSection !== prevProps.reArrangeSection)){
            this.props.onSortEnd({ oldIndex : this.props.index, newIndex: Number(this.state.currentOrder)-1 })
        }
        if(this.state.collapse && !this.props.courses.sectionLessons[this.props.value.id] && this.state.collapse !== prevState.collapse){
            this.props.getLesson(this.props.value.id);
        }
        if(prevProps.courses.creatingLesson && !this.props.courses.creatingLesson && (prevProps.courses.creatingLesson !== this.props.courses.creatingLesson)){
            this.props.getLesson(this.props.value.id);
            this.props.getSection(this.props.value.subcourseId)
        }
        
        if(this.props.courses.sectionLessons[this.props.value.id] !== prevProps.courses.sectionLessons[this.props.value.id] || this.props.courses.sectionLessons[this.props.value.id] && this.state.items.length === 0 || (prevProps.courses.deletingLesson && !this.props.courses.deletingLesson)){
            const { courses , value } = this.props
            let lessons = courses.sectionLessons[this.props.value.id]
            if(lessons){
            let items = []
            forOwn(value.lessons, function (val, key) {
                lessons.forEach(lesson => {
        
                if (lesson.id === key) {
                  let obj = {
                    ...lesson,
                    index: val
                  }
                  items.push(obj);
                }
              })
            })
            this.setState({ items: sortByPropText(items, 'index') })
            }
        }


        if((this.state.currentOrder !== this.props.value.index && this.props.value.index)){
            this.props.updateSectionIndex(this.props.value.id, Number(this.props.index)+1)
            this.setState((state, props) => ({currentOrder: Number(props.value.index)}));
        }
        if((prevProps.courses.togglePublishStatus && !this.props.courses.togglePublishStatus) || (prevProps.courses.deletingSection && !this.props.courses.deletingSection) || prevProps.courses.setNode && !this.props.courses.setNode){
            this.setState({ showModal : false })
        }
    }

    // sortItems = (type) => {
    //     this.setState(state => ({sortType : type , sortDirection : !state.sortDirection}))
    // }

    componentDidMount() {
        this.setState((state, props) => ({currentOrder: Number(props.index)+1}));      
    }


    toggleLesson() {
        this.setState(state => ({ lessonToggle: !state.lessonToggle }))
        this.props.toggleCards(this.props.subIndex);
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(({ items }) => ({
            items: arrayMove(items, oldIndex, newIndex),
        }));
        if(this.state.diff.length > 0) {
            this.props.updateIndexLesson(this.props.value.id, this.state.diff);
            this.setState({ diff : [] })
        }

    };

    togglePublish = () => this.props.toggleSectionStatus(this.props.value, !this.props.value.published)
    selectNode = () => { this.state.selectedNode.value && this.props.setSectionNode(this.props.value.id, this.state.selectedNode.value ) }
    deleteSubcourse = () => { this.props.deleteSection(this.props.value.id, this.props.value.subcourseId) }

    showModal(subcourse, action) {
        let modalText = "";
        let desc = "";
        let modalAction;
        if (action === "delete") {
          modalText = `Attempting to delete ${subcourse.name} (${subcourse.displayName}). Are you sure you want to delete this subcourse? This action cannot be reversed. All subcourse data will be lost. (If you want to hide the subcourse from users, click the "unpublish" icon.)`;
          desc = "Delete";
          modalAction = this.deleteSubcourse;
        }
        if(action === "node"){
            modalText = `Select a knowledge map node to associate with ${subcourse.name}.`;
            desc = "Select"
            modalAction = this.selectNode;
        } else if (action === "publish") {
          if (subcourse.published) {
            modalText = `Please confirm that you would like to UNPUBLISH ${subcourse.name} (${subcourse.displayName}). Once unpublished, the subcourse and its published sections will no longer be accessible as part of the course. Unpublishing does not delete data.`;
            desc = "UNPUBLISH";
            modalAction = this.togglePublish;
          } else {
            modalText = `Please confirm that you would like to publish ${subcourse.name} (${subcourse.displayName}). Once published, the subcourse and its published sections will be included in the course, and will be accessible to licensed users.`;
            desc = "Publish";
            modalAction = this.togglePublish;
          }
        }
        this.setState({
          showModal: true,
          modalText,
          desc,
          modalAction
        });
      }

      getModal() {
        return (
          <Modal isOpen={this.state.showModal} className={"modal-success"}>
            <ModalHeader>{this.state.desc} Subcourse</ModalHeader>
            <ModalBody>{this.state.modalText}
                {(this.state.desc === "Select") &&  
                 (this.props.nodes && 
                 <Select className="my-3" onChange={this.handleNodeChange} value={this.state.selectedNode} options={values(this.props.nodes).map(node => { return { 'value' : node.id , 'label' : node.name } })}  />
                  ) }</ModalBody>
            <ModalFooter>
              <Button onClick={() => this.state.modalAction()} color="secondary">
                { (this.props.courses.togglePublishStatus || this.props.courses.deletingSection || this.props.courses.setNode) 
                        ? <div className="m-auto text-center"><PulseLoader loading color={'#4c6572'}  /></div> 
                        : this.state.desc
                }
              </Button>
              <Button
                onClick={() => this.setState({ showModal: false })}
                color="secondary"
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        );
      }

    handleOrderChange = (e) => {
        this.setState({  currentOrder : e.target.value })
    }

   
    shouldCancelStart = () => {
        if (!this.state.lessonToggle) return false;
    }

    toggleAdd() {
        this.setState(state => ({ addSection: !state.addSection }))
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
    }
  

    reArrangeLesson = () => {
        this.setState(state => ({ reArrange: !state.reArrange }))
        this.toggleLesson()
    }

    addLesson = () => {
        this.setState(state => ({ addLesson: !state.addLesson, collapse: true }))
    }

    submit = () => {
        const { value } = this.props;
        let lesson = {
          name: this.state.name,
          displayName: this.state.name
        }
        this.props.createLesson(lesson, value)
    }

    sortData = (sortType) => {
            this.setState(state => ({sortType , sortDirection : !state.sortDirection }))
    }
    
    handleNodeChange = (selectedNode) => {
        this.setState({ selectedNode })
    }

    handleChange = (e) => {
        this.setState({ name : e.target.value  })
    }

    updateLessonIndex = (id, index) => {
        this.setState(state => {
            let arr = Array.from(state.diff)
            arr.push({ id, index })
            return { diff: arr }
          })
    }

    handleIndexChange = () => {
        (this.props.value.index !== this.state.currentOrder) && this.props.updateIndexSection(this.props.value.subcourseId, [{ index : this.state.currentOrder , id: this.props.value.id}])
    }

    render() {
        const { items, collapse, reArrange, addLesson } = this.state;
        const { index, reArrangeSection, value, courses } = this.props
        const { currentOrder, selectedNode,sortType,sortDirection } = this.state;
        const sortedItems = sortByPropText(items,sortType,sortDirection);
        const nodeName = this.state.selectedNode.label || get(this.props.nodes , `[${value.node}]name` , 'Select a Node' )
        return (
            <div>
                <div className={`draggable-row ${collapse ? 'active' : ''}`}><span className={`mr-1 table-collapse-${collapse ? 'down' : 'right'}`} onClick={this.toggle} ></span>
                    {reArrangeSection && <DragHandle />}
                    {reArrangeSection && <Input onBlur={() => this.handleIndexChange()} className="row-order-box mr-2" onChange={this.handleOrderChange} value={Number(currentOrder)} />}
                    <span className="draggable-row-text mr-1">{value.name} [{(items.length > 0 && items.length) ||  `${!!Object.values(value.lessons).filter(index => index !== "-1").length ? Object.values(value.lessons).filter(index => index !== "-1").length : 0}`}]</span>
                    <span onClick={() => this.showModal(value, "publish")} id={`tooltip-${value.id}-publish`} className={`${!value.published ? 'unpublished' : 'published'}-icon draggable-title-icons mx-1`}></span>
                    <span onClick={() => this.showModal(value, "node")} id={`tooltip-${value.id}-Node`} className="node-icon draggable-title-icons mx-1"></span>
                    <span className="preview-icon draggable-title-icons mx-1"></span>
                    <span onClick={this.reArrangeLesson} id={`tooltip-${value.id}-rearrange`} className={`${reArrange ? 'active' : ''} rearrange-icon draggable-title-icons mx-1`}></span>
                    <Link  id={`tooltip-${value.id}-edit`} className="draggable-title-icons mx-1" to={`/author/section/${value.id}`}><i className="edit-contents-icon"></i></Link>
                    <i id={`tooltip-${value.id}-new`} onClick={this.addLesson} className="draggable-title-icons mx-1 add-contents-icon" />
                    <i  id={`tooltip-${value.id}-delete`} style={{width : '20px', height : '20px'}} onClick={() => this.showModal(value, "delete")} className="mx-1 draggable-title-icons delete-icon" />
                    <UncontrolledTooltip target={`tooltip-${value.id}-Node`} >{nodeName}</UncontrolledTooltip>
                    <UncontrolledTooltip target={`tooltip-${value.id}-publish`} >{value.published ? 'Unpublish' : 'Publish'}</UncontrolledTooltip>
                    <UncontrolledTooltip target={`tooltip-${value.id}-rearrange`} >Rearrange Lessons</UncontrolledTooltip>
                    <UncontrolledTooltip target={`tooltip-${value.id}-edit`} >Edit Section</UncontrolledTooltip>
                    <UncontrolledTooltip target={`tooltip-${value.id}-new`} >Add New Lesson</UncontrolledTooltip>
                    <UncontrolledTooltip target={`tooltip-${value.id}-delete`} >Delete Section</UncontrolledTooltip>

                </div>
                <Collapse isOpen={this.state.collapse}>
                    {
                    (courses.fetchingLesson && items.length ===0) 
                    ? <div className="m-auto text-center"><PulseLoader loading color={'#4c6572'}  /></div> 
                    :  
                        <React.Fragment>
                        {items.length === 0 && <Alert
                            color="danger"
                        >{`No Lessons Added`}</Alert>}
                          <Table striped size="sm" className="edit-lesson-table">
                            <thead>
                            <tr> 
                                {reArrange && <th style={{ width: '25px' }}></th>}
                                <th  style={{ width: '80px' }}>Order<i className="arrow-down ml-2" onClick={() => this.sortData('index')} /></th>
                                {reArrange && <th style={{ width: '25px' }}></th>}
                                {reArrange && <th style={{ width: '25px' }}></th>}
                                {reArrange && <th style={{ width: '25px' }}></th>}
                                <th><i className="lesson-icon mr-2" />Lesson Name<i onClick={() => this.sortData('name')} className="arrow-down ml-2" /></th>
                            <th><i className="deck-icon mr-2" />Decks<i  className="arrow-down ml-2" /></th>
                            <th><i className="items-icon mr-2" />Items<i  className="arrow-down ml-2" /></th>
                            <th><i className="rules-icon mr-2" />Rules<i    className="arrow-down ml-2" /></th>
                      
                            </tr>
                        </thead>
                        {items.length > 0 ? <SortableContainer lockToContainerEdges lockAxis={'y'} helperClass={'dragging-lesson'} shouldCancelStart={this.shouldCancelStart} distance={1} useDragHandle onSortEnd={this.onSortEnd}>
                            {sortedItems.map((item, index) => (
                                <SortableItem updateLessonIndex={this.updateLessonIndex} addLesson={addLesson} reArrange={reArrange} toggleCard={this.props.toggleCard} onSortEnd={this.onSortEnd} toggle={this.props.toggle} key={`item-${index}`} section={value} index={index} lastItem={items.length} value={item} />
                            ))}
                        </SortableContainer> :
                            <tbody>{<tr className="new-item-section scroll-to-lesson">
                                <td colSpan={reArrange ? 5 : 1}></td>
                                <td className="p-0 subcourse-head">Add new Lesson</td>
                                <td colSpan="2" sm="9"><Input value={this.state.name} onChange={this.handleChange} placeholder={'Enter Lesson Name ..'} /></td>
                                <td colSpan="1" sm="3" className="pl-0">
                                    <Button className="w-100" disabled={this.state.name === ''} onClick={this.submit}>{courses.creatingLesson ? <div className="m-auto"><PulseLoader loading color={'#fff'} size={10} /></div> : 'Save'}</Button>
                                </td>
                            </tr>}</tbody>
                        }

                    </Table>
                    </React.Fragment>
                    }
                    <div>
                        <Modal isOpen={this.state.showPublishModal} toggle={this.showPublishModal} className={this.props.className}>
                            <ModalBody>
                                {`Please confirm that you would like to publish ${'record.name'} (${'record.displayName'}). Once published, the ${'record.collectionName'} and its published ${'record.childCollectionName'}s will be included in the course, and will be accessible to licensed users.`}

                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={this.showPublishModal}>Save</Button>{' '}
                                <Button color="secondary" onClick={this.showPublishModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal isOpen={this.state.showNodeModal} toggle={this.showNodeModal} className={this.props.className}>
                            <ModalBody>
                                {`Select a knowledge map node to associate with ${`ACT Mastery English`}.`}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={this.showNodeModal}>Select</Button>{' '}
                                <Button color="secondary" onClick={this.showNodeModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>

                    </div>
                </Collapse>
                    {this.getModal()}
            </div>

        );
    }
}


const mapStateToProps = state => {
    return {
      courses: state.courses,
      nodes: state.assessment.nodes
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        updateIndexLesson: (sectionId, indexes) => { dispatch(courses.updateIndexLesson(sectionId, indexes)) },
        updateIndexSection: (subcourseId, indexes) => { dispatch(courses.updateIndexSection(subcourseId, indexes)) },
        toggleSectionStatus: (section, status) => { dispatch(courses.toggleSectionStatus(section, status)) },
        createLesson: (lesson, section) => { dispatch(courses.createLesson(lesson, section)) },
        getLesson: (sectionId) => { dispatch(courses.getLesson(sectionId)) },
        deleteSection: (sectionId, subcourseId) => { dispatch(courses.deleteSection(sectionId, subcourseId)) },
        getSection: (subcourseId) => { dispatch(courses.getSection(subcourseId))},
        setSectionNode: (sectionId, nodeId) => { dispatch(courses.setSectionNode(sectionId, nodeId)) }
 
    }
  }
  
  
  export default connect(mapStateToProps, mapDispatchToProps)(SectionCollapsable)


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorCollapsable/SectionCollapsable.js